import { render, staticRenderFns } from "./AlertRecordList.vue?vue&type=template&id=1600d52e&scoped=true&"
import script from "./AlertRecordList.vue?vue&type=script&lang=js&"
export * from "./AlertRecordList.vue?vue&type=script&lang=js&"
import style0 from "./AlertRecordList.vue?vue&type=style&index=0&id=1600d52e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1600d52e",
  null
  
)

export default component.exports